import DashboardLayout from "@/layout/DashboardLayout.vue";

import NotFound from "@/pages/NotFoundPage.vue";
import Error404List from "@/pages/Lists/Error404.vue";
import Dashboard from "@/pages/Dashboard.vue";

import Login from "@/pages/Login.vue";
import Logout from "@/pages/Logout.vue";
import SingleUser from "@/pages/Editors/User.vue";
import SingleRole from "@/pages/Editors/Role.vue";
import UserProfile from "@/pages/Users/UserProfile.vue";
import RecuperaPassword from "@/pages/RecuperaPassword.vue";
import ResetPassword from '@/pages/ResetPassword.vue'
import UserList from "@/pages/Users/UserList.vue";
import RoleList from "@/pages/Lists/Role.vue";
import RedazioneList from "@/pages/Users/RedazioneList.vue";
import RedazioneDetail from "@/pages/Users/RedazioneDetail.vue";

import EventList from "./pages/lists/Event.vue";
import Event from "./pages/editors/Event.vue";
import NewsList from "@/pages/Lists/News.vue";
import News from "@/pages/Editors/News.vue";
import IATList from "@/pages/Lists/IAT.vue";
import IAT from "@/pages/Editors/IAT.vue";
import ItinerariList from "@/pages/Lists/Itinerari.vue";
import Itinerary from "@/pages/Editors/Itinerary.vue";
import LocalityList from "./pages/lists/Locality.vue";
import Locality from "./pages/editors/Locality.vue";
import InteressiList from "@/pages/Lists/Interessi.vue";
import Interessi from "@/pages/Editors/Interessi.vue";
import ViaEmiliaList from "@/pages/Lists/ViaEmilia.vue";
import ViaEmilia from "@/pages/Editors/ViaEmilia.vue";
import WebcamList from "@/pages/Lists/Webcam.vue";
import Webcam from "@/pages/Editors/Webcam.vue";
import OpenDataList from "@/pages/Lists/OpenData.vue";
import OpenData from "@/pages/Editors/OpenData.vue";
import DownloadList from "@/pages/Lists/Download.vue";
import Download from "@/pages/Editors/Download.vue";
import Gallery from "@/pages/Gallery.vue";
import PageList from "@/pages/Lists/Page.vue";
import Page from "@/pages/Editors/Page.vue";
import TipologiaLuoghiList from "@/pages/Lists/TipologiaLuoghi.vue";
import LuoghiList from "@/pages/Lists/Luogo.vue";
import Luogo from "@/pages/Editors/Luogo.vue";
import Tags from "@/pages/Lists/Tags";
import TagsDetail from "@/pages/Editors/TagsDetail";
import HomeSettings from "./pages/settings/HomeSettings.vue";
import HomeSettingsExtra from "@/pages/HomeSettingsExtra.vue";
import MakeXPList from "@/pages/Lists/MakeXP";
import TrekkSoftList from "@/pages/Lists/TrekkSoft";
import CategoryList from "@/pages/Lists/Category";

/* Destinazioni */

import Allegati from "./pages/lists/Allegati";
import NataleCapodanno from "./pages/lists/NataleCapodanno";
import BlogsList from "./pages/lists/BlogsList";
import EsperienzeList from "./pages/lists/EsperienzeList";
import OperatoriList from "./pages/lists/OperatoriList";
import ProposteSoggiornoList from "./pages/lists/ProposteSoggiornoList";


import Blogs from "./pages/editors/Blogs";
import Esperienza from "./pages/editors/Esperienza";
import Operatore from "./pages/editors/Operatore";
import ProposteSoggiorno from "./pages/editors/ProposteSoggiorno";

import FoodWineSettings from "./pages/settings/FoodWineSettings.vue";
import InstagramSettings from "./pages/settings/InstagramSettings.vue";
import TermeOutdoorSettings from "./pages/settings/TermeOutdoorSettings.vue";
import CulturaCastelliSettings from "./pages/settings/CulturaCastelliSettings.vue";


import Valle from "./pages/editors/Valle";
import ValliList from "./pages/lists/ValliList";

const routes = [
    {
        path: "/login",
        name: "login",
        component: Login
    },
    {
        path: "/password/reset",
        name: "recovery",
        component: RecuperaPassword
    },
    {
        path: "/password/reset/:code",
        name: "recovery-change",
        component: ResetPassword,
        props: true
    },
    {
     //   base: '/backend/',
        path: "/",
        component: DashboardLayout,
        redirect: "/login",
        children: [
            {
                path: "dashboard",
                name: "dashboard",
                component: Dashboard,
            },
            {
                path: "users",
                name: "Utenti",
                component: UserList,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "users/roles",
                name: "Ruoli",
                component: RoleList,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "users/roles/:id",
                name: "Role",
                component: SingleRole,
                props: true,
            },

            {
                path: "users/redazioni",
                name: "Redazioni",
                component: RedazioneList,
            },
            {
                path: "users/:id",
                name: "User",
                component: SingleUser,
                props: true,
            },
            {
                path: "users/redazioni/:id",
                name: "RedazioneDetail",
                component: RedazioneDetail,
                props: true,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "user/profile",
                name: "Profilo Utente",
                component: UserProfile
            },
            {
                path: "user/logout",
                name: "Logout",
                component: Logout,
            },
            {
                path: "events",
                name: "Eventi",
                component: EventList,
            },
            {
                path: "events/:id",
                name: "Gestione Evento",
                component: Event,
                props: true,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "news",
                name: "News",
                component: NewsList,

            },
            {
                path: "news/:id",
                name: "Gestione News",
                component: News,
                props: true,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "iat",
                name: "Uffici I.A.T.",
                component: IATList,

            },
            {
                path: "iat/:id",
                name: "Gestione Ufficio Informazione",
                component: IAT,
                props: true,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "itinerary",
                name: "Elenco Itinerari",
                component: ItinerariList,

            },
            {
                path: "itinerary/:id",
                name: "Gestione Itinerario",
                component: Itinerary,
                props: true,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "locality",
                name: "Elenco Località",
                component: LocalityList,

            },
            {
                path: "locality/:id",
                name: "Gestione Località",
                component: Locality,
                props: true,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "opendata-list",
                name: "Open Data",
                component: OpenDataList,
            },
            {
                path: "makexp-list",
                name: "MakeXp",
                component: MakeXPList,
            },
            {
                path: "trekksoft-list",
                name: "TrekkSoft",
                component: TrekkSoftList,
            },
            {
                path: "download-list",
                name: "Download",
                component: DownloadList,
            },
            {
                path: "viaemilia",
                name: "Elenco Via Emilia",
                component: ViaEmiliaList,
                props: true,

            },
            {
                path: "viaemilia/:id",
                name: "Gestione Viaemilia",
                component: ViaEmilia,
                props: true,

            },
            {
                path: "interessi-list/:main/:name_interest",
                name: "Elenco Interessi",
                component: InteressiList,
                props: true,

            },
            {
                path: "webcam-list",
                name: "Elenco Webcam",
                component: WebcamList,

            },
            {
                path: "page",
                name: "Elenco Pagine Statiche",
                component: PageList,

            },
            {
                path: "page/:id",
                name: "Gestione Pagine Statiche",
                component: Page,
                props: true,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "punti-interesse",
                name: "Elenco Tipologia Luoghi",
                component: TipologiaLuoghiList,

            },
            {
                path: "punti-interesse/:code",
                name: "Elenco POI",
                component: LuoghiList,
                props: true,

            },
            {
                path: "luogo/:id/:code",
                name: "Gestione Luogo",
                component: Luogo,
                props: true,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "category-list/:id",
                name: "Editor Categoria",
                props: true,
                component: CategoryList,

            },
            {
                path: "not-found",
                name: "not-found",
                component: NotFound
            },
            {
                path: "opendata/:id/:path",
                name: "Gestione OpenData",
                component: OpenData,
                props: true,
            },
            {
                path: "download/:id/:path",
                name: "Gestione Download",
                component: Download,
                props: true,
            },
            {
                path: "interessi/:id/:path/:theme",
                name: "Gestione Interessi",
                component: Interessi,
                props: true,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "webcam/:id/:path",
                name: "Gestione Webcam",
                component: Webcam,
                props: true,
                meta: {
                    permissions: [{
                        role: 'redazione',
                        access: false,
                        redirect: 'not-found'
                    }]
                }
            },
            {
                path: "gallery-frame/:alone",
                name: "media",
                component: Gallery,
                props: true
            },
            {
                path: "gallery-frame-entity/:alone",
                name: "Gestione Media",
                component: Gallery,
                props: true
            },
            {
                path: "error404-list",
                name: "Errori 404",
                component: Error404List,
            },
            {
                path: "home-settings",
                name: "Home",
                component: HomeSettings,
            },
            {
                path: "home-settings-extra",
                name: "Extra",
                component: HomeSettingsExtra,
            },
            {
                path: "tags",
                name: "Tags",
                component: Tags,
            },
            {
                path: "tags/:id",
                name: "TagsDetail",
                component: TagsDetail,
                props: true,
            },
            /* ROTTA PER I BLOGS */
            {
                path: "blog",
                name: "Blogs",
                component: BlogsList,

            },
            {
                path: "blog/:id",
                name: "Gestione Articoli",
                component: Blogs,
                props: true,

            },
            {
                path: "operatori",
                name: "Operatori",
                component: OperatoriList,

            },
            {
                path: "operatori/:id",
                name: "Gestione Operatore",
                component: Operatore,
                props: true,

            },
            {
              path: "valli",
              name: "Valli",
              component: ValliList,

          },
          {
              path: "valle/:id",
              name: "Gestione Valli",
              component: Valle,
              props: true,

          },
            /* ROTTA PROPOSTE DI SOGGIORNO */
            {
                path: "soggiorno",
                name: "Lista Proposte",
                component: ProposteSoggiornoList,

            },
            {
                path: "soggiorno/:id",
                name: "Gestione proposte",
                component: ProposteSoggiorno,
                props: true,

            },
            {
                path: "allegati",
                name: "Gestione Allegati",
                component: Allegati
            },
            {
              path: "natale-capodanno",
              name: "NataleCapodanno",
              component: NataleCapodanno
          },
            {
                path: "esperienze",
                name: "Lista Esperienze",
                component: EsperienzeList,

            },
            {
                path: "esperienze/:id",
                name: "Gestione esperienze",
                component: Esperienza,
                props: true,

            },
            /* ROTTE SETTINGS */
            {
                path: "food-wine-settings",
                name: "Food&Wine",
                component: FoodWineSettings,
            },
            {
                path: "instagram-settings/:griglia?",
                name: "Instagram",
                component: InstagramSettings,
            },
            {
                path: "terme-outdoor-settings",
                name: "Terme&Outdoor",
                component: TermeOutdoorSettings,
            },
            {
                path: "cultura-castelli-settings",
                name: "Cultura&castelli",
                component: CulturaCastelliSettings,
            },
        ]
    },
];

export default routes;
